import React, { useEffect, useRef, useState } from "react";
import { GrMoreVertical } from "react-icons/gr";
import { LuSearch } from "react-icons/lu";
import Pagination from "../../components/pagination/pagination";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/button/button";
import { useDispatch } from "react-redux";
import successToast from "../../components/toasts/successToast";
import errorToast from "../../components/toasts/errorToast";
import moment from "moment";
import {
    folderDelete,
    folderListAction,
} from "../../redux/actions/folderAction";
import { useAuth } from '../../context/AuthContext';

export const Folders = () => {
    const { isAdmin } = useAuth();
    const [data, setData] = useState([]);
    const [filterTerm, setFilterTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationData, setPaginationData] = useState({});
    const [showOptions, setShowOptions] = useState(false);
    const [showClearIndex, setShowClearIndex] = useState(null);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        dispatch(
            folderListAction(
                { page, page_size: rowsPerPage, search: filterTerm },
                onSuccess,
                onError
            )
        );
    }, [page, rowsPerPage, dispatch]);

    useEffect(() => {
        setLoading(true);
        dispatch(
            folderListAction(
                { page, page_size: rowsPerPage, search: filterTerm },
                onSuccess,
                onError
            )
        );
    }, [dispatch, filterTerm]);

    const onSuccess = (data) => {
        setPaginationData(data?.data?.data?.pagination);
        setData(data?.data?.data?.folders);
        setLoading(false);
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    const handleMoreOptionsClick = (item, index) => {
        setShowClearIndex(index);
        setShowOptions(!showOptions);
    };

    const handleDeleteClick = (id) => {
        setLoading(true);
        dispatch(folderDelete({ id }, onDeleteSuccess, onError));
    };

    const onDeleteSuccess = (data) => {
        dispatch(
            folderListAction(
                { page, page_size: rowsPerPage, search: filterTerm },
                onSuccess,
                onError
            )
        );
        setShowOptions(false);
        setShowClearIndex(null);
        successToast(data?.data?.message);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowOptions(false);
            setShowClearIndex(null);
        }
    };

    return (
        <div className="d-flex  h-100" onClick={handleClickOutside}>
            <div className="w-100">
                <div className="w-100 header align-items-center border-bottom  d-flex position-sticky top-0 bg-white py-2 justify-content-between">
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">
                        Folders
                    </h2>
                    {isAdmin && (
                        <CustomButton
                            className="cursor_pointer fs_18 pb-1 mx-5 d-flex align-items-center justify-content-center text-nowrap"
                            style={{ height: "35px", width: "115px" }}
                            variant="primary"
                            onClick={() => navigate("/add-folder")}
                        >
                            Add Folder +
                        </CustomButton>
                    )}
                </div>
                <div className="mt-4 mx-4 overflow-auto ">
                    <div className="input-group mb-3">
                        <span className="input-group-text gap-2">
                            <LuSearch />
                            Search
                        </span>
                        <input
                            type="text"
                            className="input-field w-75"
                            placeholder="Enter user name or value"
                            value={filterTerm}
                            onChange={(e) => setFilterTerm(e.target.value)}
                        />
                    </div>
                    <div
                        className="table-responsive"
                        style={{ minHeight: "32rem", minWidth: "100%" }}
                    >
                        <table className="table table-bordered">
                            <thead className="table-light">
                                <tr className="text-start text-nowrap">
                                    <th width={"10%"} className='fw_400'>Sl No.</th>
                                    <th width={"35%"} className='fw_400'>Folder Name</th>
                                    <th width={"35%"} className='fw_400'>Created Date</th>
                                    {isAdmin && <th className='fw_400'>Action</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="7">Loading...</td>
                                    </tr>
                                ) : data?.length > 0 ? (
                                    data?.map((item, index) => (
                                        <tr key={index} className="text-start">
                                            <td>{index + 1}</td>
                                            <td>{item.name}</td>
                                            <td>
                                                {moment(item?.createdAt).format("MM/DD/YY, hh:mm A")}
                                            </td>
                                            {isAdmin && (
                                                <td className="px-4">
                                                    <GrMoreVertical
                                                        className="cursor_pointer"
                                                        onClick={() => handleMoreOptionsClick(item, index)}
                                                    />
                                                    {showOptions && showClearIndex === index && (
                                                        <div
                                                            className="position-relative"
                                                            ref={dropdownRef}
                                                        >
                                                            <div
                                                                className="position-absolute"
                                                                style={{ left: "2rem" }}
                                                            >
                                                                <div className="card" style={{ width: "5rem" }}>
                                                                    <div className="card-body p-2">
                                                                        <label
                                                                            className="d-block text-danger cursor_pointer hover-effect"
                                                                            onClick={() => {
                                                                                handleDeleteClick(item.id);
                                                                            }}
                                                                        >
                                                                            Delete
                                                                        </label>
                                                                        <label
                                                                            className="d-block cursor_pointer hover-effect"
                                                                            onClick={() => {
                                                                                navigate(`/edit-folder/${item.id}`);
                                                                            }}
                                                                        >
                                                                            Edit
                                                                        </label>
                                                                        <label
                                                                            className="d-block cursor_pointer hover-effect"
                                                                            onClick={() => {
                                                                                navigate(`/view-folder/${item.id}`);
                                                                            }}
                                                                        >
                                                                            View
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7">No rows to display</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {paginationData?.total > 10 && (
                        <div className="d-flex mt-3 justify-content-end mx-3">
                            <Pagination
                                data={paginationData}
                                nextFunc={() => setPage(page + 1)}
                                prevFunc={() => setPage(page - 1)}
                                setPageRowFunc={(value) => {
                                    setPage(1);
                                    setRowsPerPage(value);
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
